import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = "https://atcgn.lkm.accenture.com/atcgn-api";
// const baseUrl = "http://localhost:1111";


export const AdminSlice = createSlice({
  name: "admin",
  initialState: {
    sessions: [],
    isLoading: false,
    error: null,
    success: false,
    timeZone:[]
    
  },
  reducers: {
    setSessions: (state, { payload }) => {
      state.sessions = Array.isArray(payload) ? payload : [];
      state.error = null;
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setSuccess: (state, { payload }) => {
      state.success = payload;
    },
    setTimeZone: (state,{payload}) => {
      state.timeZone = Array.isArray(payload) ? payload : [] ;
      state.error = null;
    }
  },
});

export const { setSessions, setLoading, setError, setSuccess,setTimeZone } =
  AdminSlice.actions;
export default AdminSlice.reducer;

export const fetchSessions = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const res = await axios.get(`${baseUrl}/sessions`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    });
    console.log("API response:", res.data);
    dispatch(setSessions(res.data));
  } catch (err) {
    dispatch(setError("Failed to fetch sessions"));
    console.error(err);
  } finally {
    dispatch(setLoading(false));
  }
};
export const fetchTimeZone = () => async(dispatch)=>{
   dispatch(setLoading(true));
  try {
    const res = await axios.get(`${baseUrl}/timeZone`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    });
    console.log("API response:", res.data);
    dispatch(setTimeZone(res.data));
  }
  catch (err) {
    dispatch(setError("Failed to fetch sessions"));
    console.error(err);
  } finally {
    dispatch(setLoading(false));
  }
}

export const uploadFile = (formData) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const res = await axios.post(`${baseUrl}/upload`, formData, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
      },
    });
    // dispatch(setSessions(res.data));
    dispatch(fetchSessions());
    dispatch(setSuccess(true));
  } catch (err) {
    dispatch(setError("Upload failed"));
    console.error(err);
  } finally {
    dispatch(setLoading(false));
  }
};

export const downloadFile =
  (filters = {}) =>
  async (dispatch) => {
    try {
      const params = {};

      if (filters.capability) params.capability = filters.capability;
      if (filters.category) params.category = filters.category;
      if (filters.modeDelivery) params.modeDelivery = filters.modeDelivery;
      if (filters.targetAudience)
        params.targetAudience = filters.targetAudience;
      if (filters.searchTerm) params.search = filters.searchTerm;
      if (filters.startDate) params.startDate = filters.startDate.toISOString();
      if (filters.endDate) params.endDate = filters.endDate.toISOString();

      const response = await axios.get(`${baseUrl}/download`, {
        params,
        responseType: "blob",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "ATCGN_Calendar_Data.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();

      dispatch(setSuccess(true));
    } catch (err) {
      dispatch(setError("Download failed"));
      console.error(err);
    }
  };
